import $ from 'jquery';

export default function() {
  $(window).scroll(() => {
    if ($(window).width() <= 768) { return; }

    const $arrow = $('[data-product-bouncing-arrow]');

    if ($(window).scrollTop() > 10) {
      $arrow.addClass('hidden');
    } else {
      $arrow.removeClass('hidden');
    }
  });
}
